export default __webpack_public_path__ + "static/media/annualReturns.001e96a3.svg";